import React from "react";

import { Downtime } from "./index";

const ChrunBlock = () => {
  return <Downtime showReload={false} title="" description="" />;
};

export default ChrunBlock;
